export enum ExpeditionCreationCriteria {
  None = 'None',
  RespectMinMax = 'RespectMinMax',
}
